module.exports = __webpack_public_path__ + "img/MDI-send.333c8851.svg";